module.exports = "/assets/3906774a04715a1eb12fd8fb0e8d7a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/R7.png
// module id = 1777
// module chunks = 0